import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AuthContext, useAuth } from 'context/AuthContext';
import { useCicloDaTela } from 'hooks/useCicloDaTela';
import { utcToZonedTime } from 'date-fns-tz';

import { TfiMedallAlt } from 'react-icons/tfi';
import {
  deleteFeedbackEcoaByQuery,
  getPlayerInfo,
  getServerTime,
  getTasksManagerEcoa,
  playerLastManager,
  updateTaskEcoa,
  getNextManagers,
  getVerifyTaskEcoa,
} from 'services/dashboard.service';

import { TaskItem } from 'components/task-item';
import { Countdown } from 'components/countdown';
import { clamp, getTaskStep } from 'utils/helpers';
import { CheckManagerType, GetTaskStatusLabel } from 'utils/strings';
import { BiUpvote } from 'react-icons/bi';
import { FaEye } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { actionLog } from 'services/actionlog.service';
import { useModal } from 'context/ModalContext';
import { HiOutlineHandThumbDown } from 'react-icons/hi2';
import { Step, User } from 'types/user';
import { getStorageItem } from 'utils/storage';
import Detail from 'pages/MissaoDestaque/Detail';
// import Header from '../components/Header';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { findLateralMenagers } from 'services/profile.service';
// import SelectGestor from '../components/SelectGestor';
// import ModalCod5 from '../components/ModalCod5';
// import CardPlus from '../components/CardPlus';

import CardIcon from 'assets/img/cards-icon.svg';
import { NotFound } from 'pages/NotFound';
import { TaskItemEcoa } from 'components/task-item-ecoa';
import { getNamedDates, GetVersion } from 'services/utils';
import AvisoDeCicloForaDaTela from 'components/ui/aviso-de-ciclo-fora-da-tela';
import CartoesCarregando from 'components/ui/cartoes-carregando';
import PageHeader from 'components/ui/page-header';
import { FOCO_VISIVEL } from 'utils/foco';
import { FaseEcoa } from 'pages/AcoesEcoa/acoes-do-semestre';
import { etapasEcoaDoCiclo, LEGENDA_DO_CALENDARIO_ECOA } from 'pages/AcoesEcoa/etapas-ecoa';
import CalendarioDoCiclo from 'pages/MinhaEquipe/components/CalendarioDoCiclo';
import CartaoDaFilaEcoa from 'pages/AcoesEcoa/components/CartaoDaFilaEcoa';
import IndicadoresEFiltrosDaFilaEcoa from 'pages/AcoesEcoa/components/IndicadoresEFiltrosDaFilaEcoa';
import SeletoresDaFilaEcoa from 'pages/AcoesEcoa/components/SeletoresDaFilaEcoa';
import TopoDaFilaEcoa from 'pages/AcoesEcoa/components/TopoDaFilaEcoa';
import VazioDaFilaEcoa from 'pages/AcoesEcoa/components/VazioDaFilaEcoa';
import { exportarAcoesEcoa } from 'pages/AcoesEcoa/exportar-acoes-ecoa';
import {
  acaoBonificada,
  acaoComCiencia,
  acaoValidada,
  aguardandoValidacao,
  CriterioDaFila,
  filtrarFila,
  indicadoresDaFila,
  linhasDaPlanilha,
  OrdemDaFila,
  ordenarFila,
  temFeedbackDoUsuario,
} from 'pages/AcoesEcoa/fila-ecoa';

export function ApreciarAcao() {
  const location = useLocation();

  const { showModal } = useModal();
  const { user, realCycle, cycleSelected, setCycleSelected } = useAuth();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [internalUser, setInternalUser] = useState<User>();

  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [gestor, setIsGestor] = useState(false);
  const [data, setData] = useState<any[]>();

  const [filteredData, setFilteredData] = useState<any[]>();

  const [validTasks, setValidTasks] = useState<unknown[]>([]);
  const [knownTasks, setKnownTasks] = useState<unknown[]>([]);
  const [doubledTasks, setDoubledTasks] = useState<unknown[]>([]);
  const [promotedTasks, setPromotedTasks] = useState<unknown[]>([]);
  const [feedbackTasks, setFeedbackTasks] = useState<number | undefined>();

  const [maxValidTasks, setMaxValidTasks] = useState(0);
  const [maxKnownTasks, setMaxKnownTasks] = useState(0);
  const [maxDoubledTasks, setMaxDoubledTasks] = useState(0);
  const [maxPromotedTasks, setMaxPromotedTasks] = useState(0);

  const [activeTabDirector, setActiveTabDirector] = useState<'diretoria' | 'rede'>('diretoria');

  const [playerInfo, setPlayerInfo] = useState<any>();

  const [stages, setStages] = useState<Step[] | undefined>([]);
  const [currentCycle, setCurrentCycle] = useState<string | undefined>();
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  // CIC-12: fora do recorte da ECOA, o seletor fica sem ciclo e a fila dá lugar ao aviso.
  const { ciclo: cicloDoApp, foraDaTela, maisRecente, trocar: trocarCicloDoApp } = useCicloDaTela(optionsCycle);
  const [activeCycleSelected, setActiveCycleSelected] = useState<any>();
  const [cycleSelectedObject, setCycleSelectedObject] = useState<any>();
  const [evaluateStage, setEvaluateStage] = useState<any>();

  const [currentStage, setCurrentStage] = useState<string | undefined>();
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [showMore, setShowMore] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedGestor, setSelectedGestor] = useState<any>();
  const [functionGestor, setFunctionGestor] = useState<string>('');
  const [getAction, setGetAction] = useState<any>(false);
  const [modalCod5, setModalCod5] = useState<any>(undefined);
  const [bonus, setBonus] = useState<any>(undefined);
  const [loadBonus, setLoadBonus] = useState(true);
  const [hasTime, setHasTime] = useState(false);


  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);
      setHasTime(true);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const isVacationManager = useMemo(() => !!internalUser && !!user && internalUser._id !== user._id, [internalUser, user]);

  const activeStageObjEvaluate = useMemo(() => {
    if (stages) {
      return stages.find(e => e.status === 'evaluation');
    }

    return {};
  }, [stages]);

  const activeStageObj = useMemo(() => {
    if (!Array.isArray(stages) || !currentStage) return undefined;

    if (currentStage === 'semestral') {
      const cycle = realCycle?.find(x => x._id === activeCycleSelected);

      const evaluationStage = stages.find(x => x.status === 'evaluation') || stages[0];
      if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return undefined;

      const _stages = {
        ...evaluationStage,
        title: 'Semestral',
        date_start: cycle?.date_start,
        date_finish: cycle?.date_end,
      };

      return _stages;
    }

    return stages.find(x => x._id === currentStage);
  }, [activeCycleSelected, currentStage, realCycle, stages]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeStageObj || activeStageObj.status !== 'evaluation' || !realDatetime) return null;

    if (
      realDatetime > activeStageObj?.evaluation_ecoa_days_step2_start &&
      realDatetime < activeStageObj?.evaluation_ecoa_days_step2_finish
    ) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step3_start &&
      realDatetime < activeStageObj?.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step4_start &&
      realDatetime < activeStageObj?.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_pitStop_start &&
      realDatetime < activeStageObj?.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step5_start &&
      realDatetime < activeStageObj?.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [activeStageObj, realDatetime]);

  // Retorna a etapa atual da missão
  // const getTaskStep = useCallback((task: any) => {
  //   if (!task || typeof task.status !== 'string') return undefined;

  //   // Etapa 2
  //   if (
  //     (task.status === 'rejeitado' || task.status === 'aguardando') &&
  //     (typeof task.stageNumber === 'undefined' || task.stageNumber === 0)
  //   ) {
  //     return 2;
  //   }

  //   // Se tiver Pit Stop
  //   if (typeof task.prosseguir_gst === 'string') {
  //     if (task.prosseguir_gst === 'next' || task.prosseguir_gst === 'stopped') {
  //       return 4.1;
  //     } else {
  //       return 5;
  //     }
  //   }

  //   // Etapa 3, 4 e 5
  //   if (typeof task.multiplicador === 'number') {
  //     if (typeof task.stageNumber === 'number') {
  //       if (task.stageNumber === 1) {
  //         return 3;
  //       } else if (task.stageNumber === 2) {
  //         return 4;
  //       } else if (task.stageNumber === 3) {
  //         return 5;
  //       }
  //     } else {
  //       // Etapa 3
  //       if (task.multiplicador === 1) {
  //         return 3;
  //       }

  //       // Etapa 3
  //       if (task.status === 'dobrado' && task.multiplicador === 2) {
  //         return 3;
  //       }

  //       // Etapa 4
  //       if (task.status === 'promovido' && task.multiplicador === 2) {
  //         return 4;
  //       }

  //       // Etapa 4
  //       if (task.status === 'dobrado' && task.multiplicador === 4) {
  //         return 4;
  //       }

  //       // Etapa 5
  //       if (task.status === 'promovido' && task.multiplicador === 4) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'dobrado' && task.multiplicador === 8) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'selo') {
  //         return 5;
  //       }
  //     }
  //   }

  //   return undefined;
  // }, []);

  const getPlayerStep = useCallback(
    (task: any) => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) {
        return 4.1;
      }

      if (typeof playerInfo.cod_etapa === 'number') {
        if (playerInfo.cod_etapa === 2) {
          return 2;
        }

        if (playerInfo.cod_etapa === 4) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (
              typeof task.multiplicador === 'number' &&
              (task.multiplicador === 1 || (typeof task.stageNumber === 'number' && task.stageNumber === 1))
            ) {
              return 3;
            } else {
              return 4;
            }
          } else {
            return 4;
          }
        }

        if (playerInfo.cod_etapa === 5) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 1) {
              return 3;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 2) {
              return 4;
            } else {
              return 5;
            }
          } else {
            return 5;
          }
        }

        if (playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else {
              return 3;
            }
          } else {
            return 3;
          }
        }

        return 0;
      }

      return 0;
    },
    [playerInfo],
  );

  const isOriginalManager = useMemo(() => {
    if (!filteredData?.length) return false;
    return !!filteredData.find(x => x.original_manager && x.original_manager === playerInfo?._id);
  }, [filteredData, playerInfo]);

  const isOriginalManagerCod5 = useMemo(() => {
    if (!filteredData?.length) return false;
    return !!filteredData.find(x => x.original_manager && x.original_manager === playerInfo?._id && playerInfo?.cod_etapa === 5);
  }, [filteredData, playerInfo]);

  const clarifyingText = useMemo(() => {
    if (
      !playerInfo ||
      !playerInfo.cod_etapa ||
      typeof playerInfo.cod_etapa !== 'number' ||
      playerInfo.cod_etapa < 1 ||
      playerInfo.cod_etapa > 5
    )
      return <></>;

    const _tasks = [...(filteredData as any[])];
    let stepMsg;

    if (playerInfo.cod_etapa === 4 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else {
          stepMsg = 2;
        }
      } else {
        stepMsg = 2;
      }
    } else if (playerInfo.cod_etapa === 5 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else if (getActiveEvaluationStep === 4 || getActiveEvaluationStep === 4.1) {
          stepMsg = 2;
        } else {
          stepMsg = 3;
        }
      } else {
        stepMsg = 3;
      }
    } else {
      if (playerInfo.cod_etapa === 2) {
        stepMsg = 0;
      } else if (playerInfo.cod_etapa === 4) {
        stepMsg = 2;
      } else if (playerInfo.cod_etapa === 5) {
        stepMsg = 3;
      } else if (playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3) {
        if (_tasks.length) {
          let hasLevel1 = false;

          _tasks.forEach(task => {
            if (
              typeof getTaskStep(task) === 'number' &&
              (getTaskStep(task) as number) >= 3 &&
              ((typeof getActiveEvaluationStep === 'number' && getActiveEvaluationStep > 2) || getActiveEvaluationStep === null)
            ) {
              hasLevel1 = true;
            }
          });

          stepMsg = hasLevel1 ? 1 : 0;
        } else {
          stepMsg = 0;
        }
      }
    }

    if (typeof stepMsg === 'number') {
      if (stepMsg === 1) {
        return (
          <>
            <p tabIndex={0} className="text-dandelion text-lg font-semibold block mb-4">Apreciação das ações validadas</p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi <strong className="font-bold">validada</strong> por funcionário pertencente à função
              gerencial e recebeu 300 (trezentos) pontos.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes em seu âmbito de atuação, e
              PROMOVER ao próximo nível, até 10% (dez por cento) das ações bonificadas que você considerar extraordinárias.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 600 (seiscentos) pontos e a{' '}
              <strong className="font-bold">promovida</strong> terá 100 (cem) pontos adicionais.
            </p>

            <p tabIndex={0} className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      } else if (stepMsg === 2) {
        return (
          <>
            <p tabIndex={0} className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 1</p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi promovida por funcionário responsável pela apreciação nível l e recebeu 600
              (seiscentos) pontos.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes para sua área de atuação, e
              PROMOVER ao próximo nível, até 10% (dez por cento) das ações bonificadas que você considerar extraordinárias.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 1.200 (um mil e duzentos) pontos e a{' '}
              <strong className="font-bold">promovida</strong> terá 100 (cem) pontos adicionais.
            </p>

            <p tabIndex={0} className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      } else if (stepMsg === 3) {
        return (
          <>
            <p tabIndex={0} className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 2</p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi promovida por funcionário responsável pela apreciação nível 2 e recebeu 1.200 (um
              mil e duzentos) pontos.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes para os desafios da sua
              Unidade/Diretoria, e conceder SELO Ação Ecoa para até 10% (dez por cento) das ações bonificadas que você considerar
              extraordinárias.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 2.400 (dois mil e quatrocentos) pontos e a que
              receber o <strong className="font-bold">SELO</strong> a 2.500 (dois mil e quinhentos) pontos.
            </p>

            <p tabIndex={0} className="text-white text-base font-light">
              E que tal deixar um feedback para a equipe? Afinal, reconhecimento nunca é demais!
            </p>
          </>
        );
      } else {
        return (
          <>
            <p tabIndex={0} className="text-dandelion text-lg font-semibold block mb-4">VALIDAÇÃO das entregas cadastradas por sua equipe</p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi cadastrada por um de seus liderados.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Para VALIDAR a entrega, verifique se há alinhamento com os indicadores e desafios da equipe, se não há informações
              sigilosas, duplicidade e ou conteúdo inadequado, caso contrário você pode DEVOLVER a ação.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              Ao ser devolvida, a ação volta para o responsável pelo cadastramento e se for corrigida, dentro do período de
              validação, você poderá analisá-la novamente.
            </p>
            <p tabIndex={0} className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">validada</strong> recebe 300 (trezentos) pontos.
            </p>

            <p tabIndex={0} className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      }
    } else {
      return <></>;
    }
  }, [filteredData, getActiveEvaluationStep, isOriginalManager, playerInfo]);

  // TO DO: Mudar nomenclatura. Esse método não é utilizado apenas para reset.
  const canReset = useCallback(
    (task: any) => {
      const _activeStageObjEvaluate = stages && stages?.find(e => e.status === 'evaluation');

      const _activeStageObj =
        activeStageObj?._id === '67203cdf2cc06079269fffc0' && evaluateStage?._id === '67241c4a81985d067f49c740'
          ? evaluateStage
          : activeStageObj;

      const end = activeStageObj?.date_evaluation_step5_finish
        ? activeStageObj?.date_evaluation_step5_finish
        : activeStageObj?.date_evaluation_step4_finish
          ? activeStageObj?.date_evaluation_step4_finish
          : activeStageObj?.evaluation_ecoa_days_step2_finish;

      if (
        !end ||
        !activeStageObj ||
        !getTaskStep(task) ||
        !getActiveEvaluationStep ||
        !playerInfo ||
        playerInfo?.ecoa === 'INTEGRANTE' ||
        !task.original_manager ||
        realDatetime < activeStageObj.evaluation_ecoa_days_step2_start ||
        realDatetime > end
      ) {
        return false;
      }

      if (
        (getActiveEvaluationStep === 2 && (getTaskStep(task) as number) >= 2) ||
        (getActiveEvaluationStep === 5 && (getTaskStep(task) as number) >= 3)
      ) {
        return true;
      }

      if (task.status === 'apreciacaoExpirada') {
        return false;
      }

      return false;
    },
    [activeStageObj, evaluateStage, getActiveEvaluationStep, playerInfo, realDatetime, stages],
  );

  function canDouble(task: any) {
    if (!canReset(task) || !getTaskStep(task) || task.status !== 'aprovado' || !activeStageObj || currentStage !== 'semestral') {
      return false;
    }

    const hasDouble = data?.filter(e => e?.multiplicador > 1);

    if (
      !!activeStageObj &&
      (!hasDouble || !hasDouble?.length || hasDouble?.length < 1) &&
      realDatetime >= activeStageObj?.date_evaluation_step5_start &&
      realDatetime <= activeStageObj?.date_evaluation_step5_finish
    ) {
      return true;
    }

    return false;
  }

  function handleFinalize(task: any) {
    if (!canReset(task) || !getTaskStep(task) || task.status !== 'aprovado' || !activeStageObj || currentStage !== 'semestral') {
      return false;
    }

    const hasDouble = data?.filter(e => e?.multiplicador > 1);

    if (
      !!activeStageObj &&
      hasDouble &&
      realDatetime >= activeStageObj?.date_evaluation_step5_start &&
      realDatetime <= activeStageObj?.date_evaluation_step5_finish
    ) {
      return true;
    }

    return false;
  }

  function canPromote(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !getActiveEvaluationStep ||
      (getTaskStep(task) !== getActiveEvaluationStep &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (getActiveEvaluationStep < 3 &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (promotedTasks.length >= maxPromotedTasks && (!bonus?.hasBonus || bonus?.isUsed)) ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number'
    ) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4.1 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8) {
        return true;
      }
    }

    if (bonus?.hasBonus && !bonus?.isUsed && task.status === 'concluidoAuto' && !isVacationManager) return true;

    return false;
  }

  function canPromoteWithNoBonus(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !getActiveEvaluationStep ||
      (getTaskStep(task) !== getActiveEvaluationStep &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (getActiveEvaluationStep < 3 &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      promotedTasks.length >= maxPromotedTasks ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number'
    ) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4.1 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8) {
        return true;
      }
    }

    return false;
  }

  function canValidate() {
    const _data = data?.filter(e => e.multiplicador >= 1);

    if (_data?.length && _data?.length >= 1) {
      return false;
    }

    return true;
  }

  function canEdit(task: any) {
    if (
      !activeStageObj ||
      activeStageObj.status !== 'evaluation' ||
      !canReset(task) ||
      (playerInfo.ecoa !== 'TUTOR' && playerInfo.ecoa !== 'COORDENADOR') ||
      task.status === 'concluido' ||
      task.status === 'concluidoAuto' ||
      task.status === 'apreciacaoExpirada'
    ) {
      return false;
    }

    if (task.status === 'aguardando') {
      return true;
    }

    if (task.status === 'aprovado' && getActiveEvaluationStep === 5) {
      return true;
    }

    if (task.multiplicador === 1 && getActiveEvaluationStep === 3) {
      return true;
    }

    if (task.status === 'promovido' && task.multiplicador === 2 && getActiveEvaluationStep === 4) {
      return true;
    }

    return false;
  }

  function canEvaluate(item: any) {
    try {
      const end = activeStageObj?.date_evaluation_step5_finish
        ? activeStageObj?.date_evaluation_step5_finish
        : activeStageObj?.date_evaluation_step4_finish
          ? activeStageObj?.date_evaluation_step4_finish
          : activeStageObj?.evaluation_ecoa_days_step2_finish;

      if (
        !!activeStageObj &&
        !!end &&
        (activeStageObj.status === 'evaluation' ||
          (activeStageObj._id === '67203cdf2cc06079269fffc0' && evaluateStage?._id === '67241c4a81985d067f49c740')) &&
        realDatetime >= activeStageObj.evaluation_ecoa_days_step2_start &&
        realDatetime <= end
      ) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  const getUserInfo = useCallback(async () => {
    try {
      const playerInfoResult = await getPlayerInfo(internalUser?._id);

      if (playerInfoResult) {
        setIsGestor(playerInfoResult.ecoa && (playerInfoResult.ecoa === 'TUTOR' || playerInfoResult?.ecoa === 'COORDENADOR'));
        setPlayerInfo(playerInfoResult);

        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }, [internalUser?._id]);

  const loadData = useCallback(
    async () => {
      if (!!activeStageObj) {
        const start =
          activeStageObj?._id === '67241c4a81985d067f49c740' && currentStage !== 'semestral'
            ? 1730174400000
            : activeStageObj.date_start;

        const end =
          activeStageObj?._id === '67203cdf2cc06079269fffc0' && currentStage !== 'semestral'
            ? 1733021999000
            : activeStageObj.date_finish;

        const myTasks = await getTasksManagerEcoa(internalUser?.extra.id, start, end);

        if (Array.isArray(myTasks) && myTasks.length) {
          setData(myTasks);
        } else {
          setData([]);
          setFilteredData([]);
          setLoading(false);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeStageObj, internalUser?.extra.id],
  );

  async function updateAllTasks(action: string, newObj: any, oldObj?: any) {
    try {
      setPageLoading(true);
      if (!!action.match(/(accept|stop|reject)/g)) {
        await updateTaskEcoa(newObj);

        return true;
      } else if (!!action.match(/(double|reset)/g)) {
        if (action === 'double') {
          const tasks = [...(filteredData as any[])].filter((x: any) => {
            if (x._id !== newObj._id && canReset(x) && x.status === 'aprovado') {
              return true;
            }

            return false;
          });

          if (tasks.length) {
            // for (const task of tasks) {
            //   await updateTaskEcoa({ ...task, status: 'concluidoAuto' });
            // }

            await actionLog('me', 'change_task_ecoa_status', {
              tasks: tasks.map((x: any) => {
                return {
                  taskId: x._id,
                  status: 'concluidoAuto',
                };
              }),
            });
          }

          await updateTaskEcoa(newObj);
          return true;
        } else {
          const tasks = [...(filteredData as any[])].filter((x: any) => {
            if (x._id !== newObj._id && canReset(x) && x.status === 'concluidoAuto') {
              return true;
            }

            return false;
          });

          if (tasks.length) {
            // for (const task of tasks) {
            //   await updateTaskEcoa({ ...task, status: 'dobrado' });
            // }

            await actionLog('me', 'change_task_ecoa_status', {
              tasks: tasks.map((x: any) => {
                return {
                  taskId: x._id,
                  status: 'aprovado',
                };
              }),
            });
          }

          await updateTaskEcoa(newObj);
          return true;
        }
      }
    } catch (error) {
    } finally {
      await loadData();
      setPageLoading(false);
    }

    return null;
  }

  async function handleReset(task: any) {
    if (!canReset(task)) return false;

    const newObj = { ...task };

    //delete newObj.evaluator;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      delete newObj.stageNumber;
      delete newObj.multiplicador;
      delete newObj.prosseguir_gst;
      delete newObj.prosseguir_idGestor;
      delete newObj.prosseguir_who_approved;

      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        newObj.status = 'aguardando';
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep && getActiveEvaluationStep < 5) {
          newObj.status = 'aguardando';
        } else {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }
      }

      await deleteFeedbackEcoaByQuery(`taskId:'${newObj._id}'`);
    } else {
      if (getActiveEvaluationStep === 2) {
        delete newObj.stageNumber;
        delete newObj.multiplicador;
        delete newObj.prosseguir_gst;
        delete newObj.prosseguir_idGestor;
        delete newObj.prosseguir_who_approved;
        delete newObj.evaluatedBy;

        newObj.status = 'aguardando';

        await deleteFeedbackEcoaByQuery(`taskId:'${newObj._id}'`);
      } else {
        // if (!!task.evaluator?.length && task.evaluator.includes(String(playerInfo._id))) {
        //   newObj.evaluator = [];

        //   for (let index = 0; index < task.evaluator.length; index++) {
        //     const id = task.evaluator[index];

        //     newObj.evaluator.push(id);

        //     if (id === String(playerInfo._id)) {
        //       break;
        //     }
        //   }
        // }

        if (getActiveEvaluationStep && getActiveEvaluationStep > 2) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;

          if (newObj.status === 'dobrado') {
            newObj.evaluatedBy.pop();
          }

          newObj.status = 'aprovado';
          newObj.multiplicador = 1;
          newObj.stageNumber = 1;
        } else if (getActiveEvaluationStep === 4) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;

          newObj.status = 'promovido';
          newObj.multiplicador = 2;
          newObj.stageNumber = 2;
        } else if (getActiveEvaluationStep === 4.1) {
          delete newObj.prosseguir_who_approved;

          newObj.prosseguir_gst = 'next';
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        } else if (getActiveEvaluationStep === 5) {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }

        if (!!newObj.feedback?.length) {
          let evaluators: any;

          if (Array.isArray(newObj.evaluator)) {
            evaluators = [newObj.original_manager, ...newObj.evaluator];
          } else {
            evaluators = [newObj.original_manager];
          }

          const evaluatorsWithoutMe = evaluators.filter((x: string) => x !== String(playerInfo._id));

          const feedbacksWithoutMe = newObj.feedback
            .filter((x: any) => {
              if (evaluatorsWithoutMe?.length) {
                const evaluatorId = x.evaluatorId.replace(/F(0+)?/g, '');
                return !evaluatorsWithoutMe.includes(evaluatorId);
              }

              return true;
            })
            .map((x: any) => x._id);

          if (feedbacksWithoutMe.length) {
            const deletedFeedbacks: any = [];

            feedbacksWithoutMe.forEach((feedbackId: string) =>
              deletedFeedbacks.push(deleteFeedbackEcoaByQuery(`_id:'${feedbackId}'`)),
            );

            await Promise.all(deletedFeedbacks);
          }
        }
      }
    }

    // if (isVacationManager) {
    //   if (!newObj.substitute_managers) {
    //     newObj.substitute_managers = [];
    //   }

    //   const timestamp = await getServerTime();

    //   newObj.substitute_managers.push({
    //     playerId: user?._id,
    //     playerName: user?.name,
    //     status: 'reset',
    //     time: { $date: timestamp },
    //   });
    // }

    await updateAllTasks('reset', newObj, task);
  }

  async function handleAccept(item: any, gestor?: string) {
    if (!!gestor) {
      const valid = [...validTasks];
      const known = [...knownTasks];

      valid.push(item);
      known.push(item);

      setValidTasks(valid);
      setKnownTasks(known);
    }

    const updatedData = { ...item };

    updatedData.status = 'aprovado';
    updatedData.multiplicador = updatedData.multiplicador || 1;
    updatedData.stageNumber = 1;
    updatedData.evaluatedBy = [playerInfo._id];

    if (playerInfo._id !== item.original_manager) {
      updatedData.evaluator = [playerInfo._id];
    }

    if (!!gestor) {
      setGetAction({ ...item, fuction: `validation-accept-${item._id}-finish` });
    }

    await updateAllTasks('accept', updatedData);
  }

  async function handleStop(item: any) {
    const managerTypeResult = CheckManagerType({
      user: playerInfo,
      item,
    });

    const updatedData = { ...item };

    if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      updatedData.prosseguir_idGestor === playerInfo._id
    ) {
      updatedData.prosseguir_gst = 'stopped';
    }

    updatedData.status = 'concluido';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'concluido',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('stop', updatedData);
  }

  async function handleReject(item: any) {
    const rejected = [...knownTasks];
    rejected.push(item);
    setKnownTasks(rejected);

    const updatedData = { ...item };
    updatedData.status = 'rejeitado';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'rejeitado',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reject', updatedData);
  }

  async function handleKnown(item: any) {
    const rejected = [...knownTasks];
    rejected.push(item);
    setKnownTasks(rejected);

    const updatedData = { ...item };
    updatedData.status = 'ciente';

    updatedData.evaluatedBy = [playerInfo._id];

    if (playerInfo._id !== item.original_manager) {
      updatedData.evaluator = [playerInfo._id];
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'ciente',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reject', updatedData);
  }

  async function handleDoubled(item: any) {
    const doubled = [...doubledTasks];
    doubled.push(item);
    setDoubledTasks(doubled);

    let multiplicador = typeof item.multiplicador === 'number' ? item.multiplicador * 3 : 1;

    const updatedData = { ...item };
    updatedData.status = 'dobrado';
    updatedData.multiplicador = multiplicador;
    updatedData.evaluatedBy = [...updatedData.evaluatedBy, playerInfo._id];

    const isEvaluator = updatedData?.evaluator?.length > 0 && updatedData.evaluator?.find((x: string) => x === playerInfo._id);

    if (!isEvaluator) {
      const evaluators = updatedData.evaluator || [];

      evaluators.push(playerInfo._id);

      updatedData.evaluator = evaluators;
    }

    await updateAllTasks('double', updatedData);
  }

  async function handlePromote(item: any, gestor?: string) {
    const managerTypeResult = CheckManagerType({
      user: playerInfo,
      item,
    });

    const nextManagers = await getNextManagers(item._id);

    const promoted = [...promotedTasks];
    promoted.push(item);
    setPromotedTasks(promoted);

    const updatedData = { ...item };

    let stageNumber = updatedData.stageNumber;

    if (getTaskStep(item) === 3) {
      stageNumber = 2;
    } else if (typeof getTaskStep(item) === 'number' && (getTaskStep(item) as number) >= 4) {
      stageNumber = 3;
    }

    let managerProsseguir: null | string = null;

    if (playerInfo.prosseguir_gst === 1 && stageNumber === 3) {
      updatedData.prosseguir_gst = 'next';
      updatedData.prosseguir_idGestor = nextManagers && nextManagers.prosseguir ? nextManagers.prosseguir._id : playerInfo.gestor;

      if (Array.isArray(updatedData.prosseguir_managers)) {
        updatedData.prosseguir_managers.push(updatedData.prosseguir_idGestor);
      } else {
        updatedData.prosseguir_managers = [updatedData.prosseguir_idGestor];
      }
    } else if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      stageNumber === 3
    ) {
      // const lastManager = await playerLastManager(internalUser?.extra.id);

      managerProsseguir = nextManagers && nextManagers.nivel3 ? nextManagers.nivel3._id : playerInfo.gestor;

      updatedData.prosseguir_gst = 'approved';
      updatedData.prosseguir_who_approved = playerInfo._id;
    }

    updatedData.status = 'promovido';
    updatedData.stageNumber = stageNumber;

    if (!updatedData.evaluator) {
      updatedData.evaluator = [];
    }

    if (managerTypeResult === 'diretoria') {
      // updatedData.multiplicador = 12;
      updatedData.status = 'selo';
      updatedData.evaluator.push('Selo Missão Destaque');
    } else if (playerInfo.gestor || managerProsseguir) {
      if (typeof managerProsseguir === 'string') {
        updatedData.evaluator.push(managerProsseguir);
        setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
      } else {
        if (updatedData.prosseguir_gst === 'next') {
          updatedData.evaluator.push(updatedData.prosseguir_idGestor);
          setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
        } else {
          if (
            playerInfo.cod_etapa === 4 &&
            String(updatedData.original_manager) === String(playerInfo._id) &&
            getActiveEvaluationStep &&
            getActiveEvaluationStep < 4
          ) {
            setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
          } else if (!gestor) {
            setSelectedGestor({
              task: item,
              cod: stageNumber === 2 ? [4] : [5],
              gestor:
                nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
                  ? nextManagers[`nivel${stageNumber}`]._id
                  : playerInfo.gestor,
            });
            setFunctionGestor(`handlePromote`);
            return;
          }

          updatedData.evaluator.push(gestor);

          // updatedData.evaluator.push(
          //   nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
          //     ? nextManagers[`nivel${stageNumber}`]._id
          //     : playerInfo.gestor,
          // );
        }
      }
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: updatedData.status,
        time: { $date: timestamp },
      });
    }

    if (
      playerInfo.cod_etapa === 4 &&
      String(updatedData.original_manager) === String(playerInfo._id) &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 4
    ) {
      delete updatedData.evaluator;
    }

    if (!!gestor) {
      setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
    }

    await updateAllTasks('promote', updatedData);
  }

  async function handleSubmitCod5(task: any) {
    setModalCod5(undefined);

    let action = 'double';

    if (task.status === 'selo') {
      action = 'promote';
    } else if (
      playerInfo.funcao_localizacao !== 3001 &&
      playerInfo.funcao_localizacao !== 3002 &&
      task.multiplicador === 4 &&
      task.stageNumber === 3 &&
      task.status === 'promovido' &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 5
    ) {
      action = 'promote';
    }

    document.dispatchEvent(
      new CustomEvent('open:modal-feedback', {
        detail: {
          _id: task._id,
        },
      }),
    );
    await updateAllTasks(action, task);
  }

  const isCurrentEvaluator = useCallback(
    (task: any) => {
      if (!internalUser || !task || !playerInfo) return false;

      let evaluators = [];

      if (!!task.original_manager?.length) {
        evaluators.push(task.original_manager);
      }

      if (Array.isArray(task.evaluator) && task.evaluator?.length) {
        evaluators = evaluators.concat(task.evaluator);
      }

      evaluators = evaluators.filter(x => !x.match(/selo/gi));

      if (evaluators.length) {
        const matriculaEvaluator = parseInt(evaluators[evaluators.length - 1].replace('F', ''));
        const currentId = parseInt(playerInfo._id);

        return matriculaEvaluator === currentId;
      } else {
        return false;
      }
    },
    [playerInfo, internalUser],
  );

  const tasksProsseguirAssessor: any[] = useMemo((): any[] => {
    if (!Array.isArray(filteredData) || !filteredData.length || !playerInfo) return [];

    const tasks = filteredData.filter(task => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return true;

      if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return true;

      return false;
    });

    return tasks;
  }, [filteredData, playerInfo]);

  const hasRede = useMemo(() => {
    if (!data || !data.length || !playerInfo || !activeStageObj) return undefined;

    const isDirector = playerInfo.cod_etapa && playerInfo.cod_etapa === 5;

    if (isDirector) {
      const itemsByStage = data?.filter(item => {
        return item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
      });

      if (itemsByStage.length) {
        return !!itemsByStage.filter(
          (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
            (!!x.prosseguir_gst && x.prosseguir_gst === 'approved') ||
            (!!x.owner_tipo_classificacao && x.owner_tipo_classificacao === 'UNIDADE TÁTICA'),
        ).length;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [activeStageObj, data, playerInfo]);

  const htmlCountdownStep = useMemo(() => {
    if (!activeStageObj || !getActiveEvaluationStep || !data || !data.length || !playerInfo) return <></>;

    const itemsByStage: any[] = [...data];

    if (itemsByStage.length) {
      const userTaskStep: number[] = itemsByStage
        ?.map(task => (typeof getPlayerStep(task) === 'number' ? (getPlayerStep(task) as number) : 0))
        .sort(() => -1);

      if (userTaskStep.includes(getActiveEvaluationStep)) {
        const date_finish =
          getActiveEvaluationStep === 2
            ? activeStageObj?.evaluation_ecoa_days_step2_finish
            : getActiveEvaluationStep === 3
              ? activeStageObj?.date_evaluation_step3_finish
              : getActiveEvaluationStep === 4
                ? activeStageObj?.date_evaluation_step4_finish
                : getActiveEvaluationStep === 4.1
                  ? activeStageObj?.date_evaluation_pitStop_finish
                  : activeStageObj?.date_evaluation_step5_finish;

        const levelTitle =
          getActiveEvaluationStep === 4.1
            ? 'Prosseguir'
            : getActiveEvaluationStep === 2
              ? 'Validação'
              : getActiveEvaluationStep === 3
                ? 'Nível 1'
                : getActiveEvaluationStep === 4
                  ? 'Nível 2'
                  : getActiveEvaluationStep === 5
                    ? 'Nível 3'
                    : null;

        return (
          <div className="py-4">
            {!!levelTitle && (
              <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
                Fluxo de apreciação atual:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">{levelTitle}</strong>
              </p>
            )}
            <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
              O período de apreciação deste nível termina em:{' '}
              <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                <Countdown key="missao" deadline={new Date(date_finish)} />
              </strong>
            </p>
          </div>
        );
      } else {
        const hasAfter = userTaskStep?.find((x: number) => x > (getActiveEvaluationStep as number));

        const date_start =
          hasAfter === 2
            ? activeStageObj?.evaluation_ecoa_days_step2_start
            : hasAfter && hasAfter >= 3
              ? activeStageObj?.date_evaluation_step5_start
              : 0;

        if (!!hasAfter && date_start) {
          return (
            <div className="py-4">
              <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
                O período de apreciação começa em:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_start)} />
                </strong>
              </p>
            </div>
          );
        } else {
          return <></>;
        }
      }
    } else {
      const codEtapa =
        playerInfo.cod_etapa === 2
          ? 2
          : playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3
            ? 3
            : playerInfo.cod_etapa === 4
              ? 4
              : playerInfo.cod_etapa === 5
                ? 5
                : null;

      if (codEtapa) {
        if (getActiveEvaluationStep === codEtapa) {
          const date_finish =
            getActiveEvaluationStep === 2
              ? activeStageObj?.evaluation_ecoa_days_step2_finish
              : getActiveEvaluationStep === 3
                ? activeStageObj?.date_evaluation_step3_finish
                : getActiveEvaluationStep === 4
                  ? activeStageObj?.date_evaluation_step4_finish
                  : activeStageObj?.date_evaluation_step5_finish;

          return (
            <div className="py-4">
              <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
                Fluxo de apreciação atual:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  {`Nível ${getActiveEvaluationStep}`}
                </strong>
              </p>
              <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </p>
            </div>
          );
        } else {
          if (getActiveEvaluationStep < codEtapa) {
            const date_start =
              codEtapa === 2
                ? activeStageObj?.evaluation_ecoa_days_step2_start
                : codEtapa === 3
                  ? activeStageObj?.date_evaluation_step3_start
                  : codEtapa === 4
                    ? activeStageObj?.date_evaluation_step4_start
                    : activeStageObj?.date_evaluation_step5_start;

            return (
              <div className="py-4">
                <p tabIndex={0} className="text-xs text-alice-blue block font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </p>
              </div>
            );
          } else {
            return <></>;
          }
        }
      } else {
        return <></>;
      }
    }
  }, [activeStageObj, data, getActiveEvaluationStep, getPlayerStep, playerInfo]);

  const taskAppreciationExpired = useCallback(
    (task: any) => {
      const _taskStep = getTaskStep(task);
      const _playerStep = getPlayerStep(task);

      if (
        activeStageObj &&
        _taskStep &&
        ((_playerStep === 2 && task.status === 'aguardando' && realDatetime > activeStageObj.evaluation_ecoa_days_step2_finish) ||
          (_playerStep === 4 &&
            _taskStep === 3 &&
            task.status === 'aprovado' &&
            task.multiplicador &&
            task.multiplicador === 1 &&
            realDatetime > activeStageObj.date_evaluation_step3_finish) ||
          (_playerStep === 5 &&
            _taskStep === 4 &&
            task.status === 'promovido' &&
            task.multiplicador &&
            task.multiplicador === 2 &&
            realDatetime > activeStageObj.date_evaluation_step4_finish))
      ) {
        return true;
      }

      return false;
    },
    [activeStageObj, getPlayerStep, realDatetime],
  );

  useEffect(() => {
    async function updateData() {
      if (typeof hasRede !== 'boolean') return setFilteredData([]);

      const isDirector = playerInfo.cod_etapa && playerInfo.cod_etapa === 5;

      try {
        let stageData: any = data?.filter(item => {
          if (currentStage === 'semestral' && item?.multiplicador >= 1) {
            return true;
          } else if (currentStage === 'semestral' && (!item?.multiplicador || item?.multiplicador < 1)) {
            return false;
          }

          if (activeStageObj?._id === '67241c4a81985d067f49c740') {
            return true;
          }

          if (activeStageObj?._id === '67203cdf2cc06079269fffc0') {
            return false;
          }

          return !!activeStageObj && item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
        });

        if (!stageData) stageData = [];

        if (hasRede) {
          if (activeTabDirector === 'rede') {
            stageData = stageData.filter(
              (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
                (!!x.prosseguir_gst && x.prosseguir_gst === 'approved') ||
                (!!x.owner_tipo_classificacao && x.owner_tipo_classificacao === 'UNIDADE TÁTICA'),
            );
          } else {
            stageData = stageData.filter(
              (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
                !x.prosseguir_gst && (!x.owner_tipo_classificacao || x.owner_tipo_classificacao !== 'UNIDADE TÁTICA'),
            );
          }
        }

        let dataWithoutProsseguir = stageData;

        if (!isDirector) {
          dataWithoutProsseguir = stageData?.filter((task: any) => {
            if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return false;

            return true;
          });
        }

        setMaxValidTasks(stageData.length);

        setMaxKnownTasks(stageData.length);

        setFeedbackTasks(stageData.filter((task: any) => temFeedbackDoUsuario(task, user?._id)).length);

        const currentMaxDoubledTasks = dataWithoutProsseguir.filter((task: any) => {
          const _taskStep = getTaskStep(task);

          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            playerInfo.cod_etapa === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return true;
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return true;
              } else {
                return task.stageNumber === 3;
              }
            }
          }

          if (
            task.status === 'rejeitado' ||
            taskAppreciationExpired(task) ||
            (typeof _taskStep === 'number' && typeof getPlayerStep(task) === 'number' && _taskStep < getPlayerStep(task)) ||
            (typeof _taskStep === 'number' &&
              typeof getActiveEvaluationStep === 'number' &&
              String(task.original_manager) !== String(playerInfo._id) &&
              isCurrentEvaluator(task) &&
              getActiveEvaluationStep < _taskStep) ||
            (playerInfo.cod_etapa === 4 && String(task.original_manager) === String(playerInfo._id) && !canReset(task))
          )
            return false;

          return true;
        });
        setMaxDoubledTasks(1);
        // setMaxDoubledTasks(clamp(Math.ceil(currentMaxDoubledTasks.length * 0.4), 1, Infinity));

        // console.log(
        //   'currentMaxDoubledTasks',
        //   currentMaxDoubledTasks.map((x: any) => x.title),
        // );

        setMaxPromotedTasks(clamp(Math.ceil(currentMaxDoubledTasks.length * 0.1), 1, Infinity));

        const currentValidTasks = stageData.filter(acaoValidada);
        setValidTasks(currentValidTasks);

        const currentKnownTasks = stageData.filter(acaoComCiencia);
        setKnownTasks(currentKnownTasks);

        const currentDoubledTasks = stageData.filter(acaoBonificada);
        setDoubledTasks(currentDoubledTasks);

        // console.log(
        //   'currentDoubledTasks',
        //   currentDoubledTasks.map((x: any) => x.title),
        // );

        const currentPromotedTasks = dataWithoutProsseguir.filter((task: any) => {
          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            playerInfo.cod_etapa === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return task.status === 'selo';
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return task.status === 'promovido' && task.multiplicador === 4 && task.stageNumber === 3;
              } else {
                return task.status === 'selo';
              }
            }
          }

          if (typeof getTaskStep(task) === 'number' && (getTaskStep(task) as number) > 2) {
            if ((getTaskStep(task) as number) === 5 && getPlayerStep(task) === 5 && task.status === 'selo') {
              return true;
            }

            if ((getTaskStep(task) as number) > getPlayerStep(task)) {
              return true;
            }

            if (
              getActiveEvaluationStep &&
              playerInfo.cod_etapa === 4 &&
              String(task.original_manager) === String(playerInfo._id) &&
              (getTaskStep(task) as number) > getActiveEvaluationStep
            ) {
              return true;
            }

            return false;
          }

          return false;
        });
        setPromotedTasks(currentPromotedTasks);

        // console.log(
        //   'currentPromotedTasks',
        //   currentPromotedTasks.map((x: any) => x.title),
        // );
        setFilteredData(stageData);

        setLoading(false);
      } catch (e) {
        setFilteredData([]);
        setLoading(false);
      }
    }

    updateData();
  }, [
    activeStageObj,
    activeTabDirector,
    canReset,
    currentStage,
    data,
    getActiveEvaluationStep,
    getPlayerStep,
    hasRede,
    isCurrentEvaluator,
    playerInfo,
    taskAppreciationExpired,
    user?._id,
  ]);

  useEffect(() => {
    if (!internalUser) return;

    setLoading(true);
    getUserInfo();
  }, [getUserInfo, internalUser]);

  useEffect(() => {
    if (!gestor || !cycleSelectedObject || !activeStageObj || !currentStage) return;

    setLoading(true);
    loadData();
  }, [gestor, loadData, cycleSelectedObject, activeStageObj, currentStage]);

  useEffect(() => {
    if (!stages) return;

    if (stages.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, stages]);

  useEffect(() => {
    try {
      const locationState: any = location.state;

      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          if (gestor) {
            loadData();
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [gestor, loadData, location]);

  useEffect(() => {
    if (!user) return;

    async function handleUser() {
      if (!!user) {
        const storedManager = getStorageItem('manager_lateralidade');

        if (!!storedManager && storedManager.length) {
          const vacationManagers = await findLateralMenagers(undefined, storedManager);

          const vacationManager = vacationManagers?.length
            ? vacationManagers.find((x: { _id: any }) => x._id === storedManager)
            : null;

          if (!!vacationManager?._id && !!vacationManager.extra?.id) {
            setInternalUser(vacationManager);
          } else {
            setInternalUser(user);
          }
        } else {
          setInternalUser(user);
        }
      }
    }

    async function handleUserWLoading() {
      setLoading(true);
      // console.log('handleUserWLoading');
      handleUser();
    }

    handleUser();

    document.addEventListener('reload:lateralidade', handleUserWLoading, false);

    return () => {
      document.removeEventListener('reload:lateralidade', handleUserWLoading);
    };
  }, [user]);

  useEffect(() => {
    if (!activeCycleSelected || !realCycle || !hasTime) return;

    setLoadBonus(true);

    const _stages = realCycle?.find(x => x._id === activeCycleSelected)?.steps;
    setStages(_stages);

    const _stageActive = _stages?.find((item: any) => item.status === 'evaluation') || (_stages && _stages[0]);
    const _id =
      !!_stageActive &&
      realDatetime >= _stageActive?.date_evaluation_step5_start &&
      realDatetime <= _stageActive?.date_evaluation_step5_finish
        ? 'semestral'
        : _stageActive?._id;

    setCurrentStage(!!_id ? _id : Array.isArray(_stages) ? _stages[0]._id : undefined);

    setCycleSelectedObject(realCycle?.find(x => x._id === activeCycleSelected));

    setEvaluateStage(_stageActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCycleSelected, realCycle, hasTime]);

  const configCycleAndStage = useCallback(() => {
    if (
      !user ||
      !realCycle ||
      !internalUser ||
      typeof currentCycle !== 'undefined' ||
      typeof currentStage !== 'undefined' ||
      !hasTime
    )
      return;

    const cycleOptions = realCycle
      .filter(item => item.date_start >= getNamedDates().ciclo_2S2024)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    const cycleActive = realCycle.find(x => x.status === 'open');
    const _currentCycle = !!cycleActive ? cycleActive._id : realCycle[0]._id;

    setOptionsCycle(cycleOptions);
    setCurrentCycle(_currentCycle);
    // CIC-12: o ciclo do app fora do recorte da ECOA não vira o ciclo da fila (a página mostra o aviso, sem ler).
    const doAppNoRecorte = cycleOptions.find(item => item._id === cycleSelected?._id)?._id;
    setActiveCycleSelected(cycleSelected?._id ? doAppNoRecorte : _currentCycle);

    const _stages = realCycle?.find(x => x._id === _currentCycle)?.steps;
    setStages(_stages);

    const _stageActive = _stages?.find((item: any) => item.status === 'evaluation');
    const _id =
      !!_stageActive &&
      realDatetime >= _stageActive?.date_evaluation_step5_start &&
      realDatetime <= _stageActive?.date_evaluation_step5_finish
        ? 'semestral'
        : _stageActive?._id;

    setCurrentStage(!!_id ? _id : Array.isArray(_stages) ? _stages[0]._id : undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCycle, currentStage, cycleSelected?._id, internalUser, realCycle, user, hasTime]);

  useEffect(() => {
    if (!user || !realCycle) return;

    configCycleAndStage();
  }, [configCycleAndStage, realCycle, user]);

  // CIC-14: trocado o ciclo do app fora da fila (pelo menu), a fila passa a ele; o efeito de `activeCycleSelected`
  // refaz as fases e relê, como na troca feita no próprio seletor.
  useEffect(() => {
    if (!cicloDoApp || typeof currentCycle === 'undefined' || cicloDoApp._id === activeCycleSelected) return;
    setActiveCycleSelected(cicloDoApp._id);
  }, [cicloDoApp, currentCycle, activeCycleSelected]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  const functionsObject: any = {
    handleAccept,
    handlePromote,
  };

  // Estado só da lista exibida (ECN-50 a ECN-52): roda no navegador sobre `filteredData`, sem tocar nas leituras.
  const [indicador, setIndicador] = useState<CriterioDaFila | null>(null);
  const [busca, setBusca] = useState('');
  const [ordem, setOrdem] = useState<OrdemDaFila>('atual');
  const tituloDaListaRef = useRef<HTMLHeadingElement>(null);

  const semestral = currentStage === 'semestral';
  const chaveDoUsuario = user?._id;
  const contextoDaFila = useMemo(() => ({ chaveDoUsuario, semestral }), [chaveDoUsuario, semestral]);
  const acoesDaFase: any[] = useMemo(() => filteredData ?? [], [filteredData]);
  const listaExibida = ordenarFila(filtrarFila(acoesDaFase, { indicador, busca }, contextoDaFila), ordem);
  const filtrosAtivos = !!indicador || !!busca.trim();

  // Props estáveis para os blocos memoizados da fila: a página re-renderiza a cada leitura e a cada segundo do
  // relógio, e os três `react-select` desses blocos são o custo dominante desse render (medido no Profiler).
  const indicadoresDaFase = useMemo(() => indicadoresDaFila(acoesDaFase, contextoDaFila), [acoesDaFase, contextoDaFila]);

  const alternarIndicador = useCallback((criterio: CriterioDaFila) => {
    setIndicador(atual => (atual === criterio ? null : criterio));
  }, []);

  const limparFiltros = useCallback(() => {
    setIndicador(null);
    setBusca('');
  }, []);

  /** Mesmo handler do seletor de ciclo de hoje. */
  const escolherCiclo = useCallback(
    (e: any) => {
      setActiveCycleSelected(e.value);
      setCycleSelectedObject(e);

      const selected = realCycle?.find(x => x._id === e.value);

      if (selected) {
        setCycleSelected({
          _id: selected._id,
          title: selected.title,
          version: GetVersion(selected.date_start),
        });
      }
    },
    [realCycle, setCycleSelected],
  );

  const opcoesDeFase = useMemo(
    () => [
      ...(evaluateStage?.date_evaluation_step5_start && evaluateStage?.date_evaluation_step5_finish
        ? [{ value: 'semestral', label: evaluateStage?.semester_title ?? 'Semestral' }]
        : []),
      ...(stages ?? [])
        .filter((fase: any) => !(fase.status !== 'evaluation' && !!isVacationManager))
        .map((fase: any) => ({ value: fase._id as string, label: fase.title as string })),
    ],
    [evaluateStage, stages, isVacationManager],
  );

  const verboDaLateralidade = playerInfo?.cod_etapa === 2 ? 'validando' : 'apreciando';
  const lateralidade = useMemo(
    () =>
      !!isVacationManager && !!internalUser
        ? {
            verbo: verboDaLateralidade,
            nome: internalUser.name,
            chave: internalUser._id,
            lotacao: `${internalUser.extra?.dependencia ?? ''} - ${internalUser.extra?.funcao ?? ''}`,
          }
        : undefined,
    [isVacationManager, internalUser, verboDaLateralidade],
  );

  const abasDaRede = useMemo(
    () => (hasRede ? { ativa: activeTabDirector, onEscolher: setActiveTabDirector } : undefined),
    [hasRede, activeTabDirector],
  );

  /** ECN-43: "Validar Ações ECOA" aplica o filtro "Aguardando sua validação" e leva o foco ao título da lista. */
  const validarAgora = useCallback(() => {
    setIndicador('aguardando');
    tituloDaListaRef.current?.focus();
  }, []);

  function exportarLista() {
    const ciclo = realCycle?.find(x => x._id === activeCycleSelected);
    exportarAcoesEcoa(linhasDaPlanilha(listaExibida, contextoDaFila), ciclo?.title ?? '', activeStageObj?.title ?? '');
  }

  const carregando = (
    <div className="mx-auto max-w-[1000px] px-4 pb-6 leading-[normal] lg:px-0">
      <CartoesCarregando />
    </div>
  );

  // Edge case "userInfo ainda não carregou": carregamento, nunca o vazio nem o "não possui acesso".
  if (
    !user ||
    !internalUser ||
    typeof gestor !== 'boolean' ||
    typeof currentCycle === 'undefined' ||
    typeof currentStage === 'undefined' ||
    !activeStageObj
  )
    return carregando;

  // SPEC_DEVIATION: a Rede vem antes do "não possui acesso" (hoje vinha depois e o usuário da Rede sem perfil ECOA via
  // "não possui acesso"). Reason: ECN-40 manda mostrar "Página não encontrada" para a Rede.
  if (user?.extra.rede) return <NotFound />;

  if (!gestor && !loading) {
    return (
      <div className="mx-auto max-w-[1000px] px-4 pb-6 leading-[normal] lg:px-0">
        <PageHeader titulo="Ações ECOA" voltar={{ to: '/', destino: 'a página inicial' }} />
        <div className="rounded-jj-panel bg-brand-white px-[26px] py-6 shadow-jj-01">
          <p className="m-0 text-center font-display text-base font-bold text-brand-blue-dark">Você não possui acesso à esta página.</p>
        </div>
      </div>
    );
  }

  if (!gestor) return carregando;

  if (showDetail) return <Detail onClose={() => setShowDetail(false)} />;

  const opcaoDoCiclo = foraDaTela
    ? undefined
    : (optionsCycle.find(x => x.value === cycleSelected?._id) ?? optionsCycle[getIndexByValue(optionsCycle, activeCycleSelected)]);

  const cicloSelecionado = realCycle?.find(x => x._id === activeCycleSelected);
  const esperandoLista = loading || !filteredData;

  return (
    <>
      {!!pageLoading && (
        <div
          className="fixed left-0 top-0 z-40 flex h-full w-full items-center justify-center bg-brand-navy/60"
          role="status"
          aria-live="polite"
          aria-label="Carregando dados"
        >
          <span className="rounded-jj-pill bg-brand-white px-5 py-3 font-display text-sm font-bold text-brand-blue-dark">Carregando...</span>
        </div>
      )}

      <div className="mx-auto max-w-[1000px] px-4 pb-6 leading-[normal] lg:px-0">
        {/* Fora do recorte, nada do ciclo anterior fica na tela: o aviso fala por ela (CIC-12). */}
        {!foraDaTela && (
          <TopoDaFilaEcoa
            fase={activeStageObj as FaseEcoa}
            ciclo={cicloSelecionado}
            agora={realDatetime}
            pendentes={acoesDaFase.filter(aguardandoValidacao).length}
            onValidar={validarAgora}
          />
        )}

        <SeletoresDaFilaEcoa
          ciclos={optionsCycle}
          ciclo={opcaoDoCiclo}
          onCiclo={escolherCiclo}
          opcoesDeFase={opcoesDeFase}
          fase={currentStage}
          onFase={setCurrentStage}
          desabilitado={loading && !foraDaTela}
          lateralidade={lateralidade}
          abasDaRede={abasDaRede}
        />

        {foraDaTela && (
          <div className="mt-3.5">
            <AvisoDeCicloForaDaTela ciclo={foraDaTela} disponivel={maisRecente} onVer={trocarCicloDoApp} />
          </div>
        )}

        <section
          hidden={!!foraDaTela}
          aria-labelledby="titulo-da-fila-ecoa"
          className="mt-3.5 rounded-jj-panel bg-brand-white px-6 pb-6 pt-[22px] shadow-jj-01"
        >
          <div className="flex flex-wrap items-center gap-[11px]">
            <h2
              id="titulo-da-fila-ecoa"
              ref={tituloDaListaRef}
              tabIndex={-1}
              className="m-0 font-display text-[17px] font-bold text-brand-blue-dark focus:outline-none"
            >
              {`Ações da fase ${activeStageObj?.title ?? ''}`}
            </h2>
            {/* SPEC_DEVIATION: fundo `brand-blue-dark` no lugar do `brand-blue` do design (amarelo de 11px no azul). */}
            <span className="whitespace-nowrap rounded-jj-pill bg-brand-blue-dark px-[11px] py-1 font-display text-[11px] font-bold text-brand-yellow">
              {`${listaExibida.length} de ${acoesDaFase.length}`}
            </span>
            <button
              type="button"
              onClick={exportarLista}
              className={`ml-auto inline-flex cursor-pointer items-center gap-[7px] whitespace-nowrap border-0 bg-transparent p-0 text-[11px] font-bold uppercase tracking-[0.05em] text-brand-blue ${FOCO_VISIVEL}`}
            >
              Exportar para Excel
              <FiDownload aria-hidden="true" size={15} strokeWidth={2.2} />
            </button>
          </div>
          <p className="m-0 mt-[7px] text-[11.5px] text-content-soft">
            Indicadores do coordenador ou tutor · clique em um indicador para filtrar a lista
          </p>

          <div className="mt-3">
            <IndicadoresEFiltrosDaFilaEcoa
              indicadores={indicadoresDaFase}
              ativo={indicador}
              onIndicador={alternarIndicador}
              busca={busca}
              onBusca={setBusca}
              ordem={ordem}
              onOrdem={setOrdem}
              naLista={listaExibida.length}
              noEscopo={acoesDaFase.length}
              onLimparFiltros={limparFiltros}
            />
          </div>

          <div className="mt-[18px] flex flex-col gap-3">
            {esperandoLista ? (
              <CartoesCarregando />
            ) : listaExibida.length ? (
              listaExibida.map(item => (
                <TaskItemEcoa
                  Visual={CartaoDaFilaEcoa}
                  semestral={semestral}
                  agora={realDatetime}
                  ecoa={true}
                  key={item._id}
                  editable={canEdit(item)}
                  data={item}
                  manager={gestor}
                  managerType={CheckManagerType({
                    user: playerInfo,
                    item,
                  })}
                  playerInfo={playerInfo}
                  canEvaluate={canEvaluate(item)}
                  canValidate={canValidate()}
                  onAccept={handleAccept}
                  double={canDouble(item)}
                  onKnown={handleKnown}
                  onDouble={handleDoubled}
                  canFinalize={handleFinalize(item)}
                  onStop={handleStop}
                  onFeedback={() => loadData()}
                  onReload={() => loadData()}
                  cycle={activeStageObj}
                  activeEvaluationStep={getActiveEvaluationStep}
                  taskStep={getTaskStep(item)}
                  playerStep={getPlayerStep(item)}
                  onReset={handleReset}
                  reset={canReset(item)}
                  getAction={getAction}
                  clearGetAction={() => setGetAction(null)}
                />
              ))
            ) : (
              <VazioDaFilaEcoa porFiltro={filtrosAtivos} onLimparFiltros={limparFiltros} />
            )}
          </div>
        </section>

        {cicloSelecionado?.status === 'open' && hasTime && (
          <CalendarioDoCiclo
            etapas={etapasEcoaDoCiclo(cicloSelecionado.steps as FaseEcoa[] | undefined)}
            agora={realDatetime}
            legenda={LEGENDA_DO_CALENDARIO_ECOA}
            titulo="Calendário do semestre"
            subtitulo={`Ciclo ${cicloSelecionado.title} · cadastramento, ciência e validação de cada mês`}
          />
        )}
      </div>

      <Outlet />
    </>
  );
}

